import sImg1 from "../images/services/service_image_1.webp";
import sImg2 from "../images/services/service_image_2.webp";
import sImg3 from "../images/services/service_image_3.webp";
import sImg4 from "../images/services/service_image_4.webp";
import sImg5 from "../images/services/service_image_5.webp";

import icon1 from "../images/icons/icon_code.svg";
import icon2 from "../images/icons/icon_programming_tree.svg";
import icon3 from "../images/icons/icon_monitor_2.svg";
import icon4 from "../images/icons/icon_phone.svg";
import icon5 from "../images/icons/icon_bug.svg";
import icon6 from "../images/icons/icon_programming.svg";

import icon7 from "../images/icons/icon_analisis_2.svg";
import icon8 from "../images/icons/icon_process.svg";
import icon9 from "../images/icons/icon_chart_2.svg";
import icon10 from "../images/icons/icon_meeting.svg";
import icon11 from "../images/icons/icon_bulb_2.svg";
import icon12 from "../images/icons/icon_speed_miter.svg";

const Services = [
  {
    Id: "1",
    sImg: sImg1,
    title: "Audit & Assurances",
    slug: "Audit-&-Assurances",
    thumb1: "IFC",
    thumb2: "Transfer pricing",
    col: "col-lg-6",
    description:
      "We offer statutory, internal, IFC, bank, transfer pricing, GST, NGO, forensic audits, and audits for Forms 10B, 15CB, and 15CA.",
  },
  {
    Id: "2",
    sImg: sImg2,
    title: "Income Tax Consultancy",
    slug: "Income-Tax-Consultancy",
    thumb1: "Tax Appeals",
    thumb2: "Investigations",
    col: "col-lg-6",
    description:
      "Preparation and rectification of tax returns, faceless assessments, and audit support. Assistance with tax appeals, investigations, and representation before tax authorities.",
  },
  {
    Id: "3",
    sImg: sImg3,
    title: "Goods & Services Tax",
    slug: "Goods-&-Services-Tax",
    thumb1: "Filing Returns",
    thumb2: "Audit Assistance",
    col: "col-lg-4",
    description:
      "GST services include registration, filing returns, GST consultancy, refunds, LUT for exporters, audit assistance, show cause notice representation, and GST appeals.",
  },
  {
    Id: "4",
    sImg: sImg4,
    title: "Accounting Services",
    slug: "Accounting-Services",
    thumb1: "IFRS",
    thumb2: "Bookkeeping",
    col: "col-lg-4",
    description:
      "Providing bookkeeping, accounting for various entities, accounting manual services, and advice on Accounting Standards, Ind AS, and IFRS.",
  },
  {
    Id: "5",
    sImg: sImg5,
    title: "Finance Registration",
    slug: "Finance-Registration",
    thumb1: "CMA data",
    thumb2: "Financial Due Diligence",
    col: "col-lg-4",
    description:
      "Offering project reports, CMA data, loan arrangements, financial due diligence, and business valuation services.",
  },
  {
    Id: "6",
    sImg: icon1,
    title: "Custom Software Development",
    slug: "Custom Software Development",
    features: [
      "Software architecture design",
      "System integration services",
      "Data migration services",
      "Legacy app modernization",
    ],
  },
  {
    Id: "7",
    sImg: icon2,
    title: "Audit & IT Consulting Services",
    slug: "Audit-&-IT-Consulting-Services",
    features: [
      "TechGuard Audit",
      "CyberSafe Audit & IT Consulting",
      "AssuranceEdge & IT Consulting",
      "IT Sentry Audit & IT Consulting",
    ],
  },
  {
    Id: "8",
    sImg: icon3,
    title: "Web Application Design and Development",
    slug: "Web-Application-Design-and-Development",
    features: [
      "Web app development services",
      "Web portal development services",
      "Website development services",
      "Offshore web development",
    ],
  },
  {
    Id: "9",
    sImg: icon4,
    title: "Mobile App Design and Development",
    slug: "Mobile-App-Design-and-Development",
    features: [
      "Android development services",
      "iOS app development services",
      "Mobile application design services",
      "Enterprise mobile app development",
    ],
  },
  {
    Id: "10",
    sImg: icon5,
    title: "Best UI/UX Design Services",
    slug: "Best-UI/UX-Design-Services",
    features: [
      "PixelPerfection UI/UX Design",
      "DesignCraft UI/UX Design",
      "CreativeWave UI/UX Design",
      "InterfaceGenius UI/UX Design",
    ],
  },
  {
    Id: "11",
    sImg: icon6,
    title: "Maintenance and Customer Support",
    slug: "Maintenance-and-Customer-Support",
    features: [
      "CareCraft Maintenance",
      "FixItPro Maintenance",
      "TechCare Maintenance",
      "AssistEdge Maintenance",
    ],
  },
  {
    Id: "12",
    sImg: icon7,
    title: "Audit & Assurances",
    slug: "Strategic-Planning-and-Execution",
    description:
      "We offer statutory, internal, IFC, bank, transfer pricing, GST, NGO, forensic audits, and audits for Forms 10B, 15CB, and 15CA.",
  },
  {
    Id: "13",
    sImg: icon8,
    title: "Income Tax Consultancy",
    slug: "Business-Process-Optimization",
    description:
      "Preparation and rectification of tax returns, faceless assessments, and audit support. Assistance with tax appeals, investigations, and representation before tax authorities.",
  },
  {
    Id: "14",
    sImg: icon9,
    title: "Goods & Services Tax",
    slug: "Digital-Transformation-Consulting",
    description:
      "GST services include registration, filing returns, GST consultancy, refunds, LUT for exporters, audit assistance, show cause notice representation, and GST appeals.",
  },
  {
    Id: "15",
    sImg: icon10,
    title: "Socities & Trusts (NGOs)",
    slug: "Strategic-Planning-and-Executions",
    description:
      "Offering project reports, CMA data, loan arrangements, financial due diligence, and business valuation services.",
  },
  {
    Id: "16",
    sImg: icon11,
    title: "Accounting Services",
    slug: "Change-Management-Solutions",
    description:
      "Providing bookkeeping, accounting for various entities, accounting manual services, and advice on Accounting Standards, Ind AS, and IFRS.",
  },
  {
    Id: "17",
    sImg: icon12,
    title: "Finance Registration",
    slug: "Performance-Metrics-and-KPI-Development",
    description:
      "Offering project reports, CMA data, loan arrangements, financial due diligence, and business valuation services.",
  },
];

export default Services;
